import { Skeleton } from 'lmcv/components/Skeleton'

import * as S from './styled'

function Loading () {
  return (
    <S.Wrapper>
      <div>
        <S.Picture>
          <Skeleton width="95px" height="95px" rounded center />
        </S.Picture>

        <S.Content>
          <S.Title>
            <Skeleton width="130px" height="19px" center />
          </S.Title>

          <S.Description>
            <Skeleton width="110px" height="18px" center />
            <Skeleton width="90px" height="18px" center />
          </S.Description>
        </S.Content>
      </div>

      <div>
        <S.Divider />
        <S.Bottom>
          <Skeleton width="130px" height="40px" rounded center />
          <S.TextFooter>
            <Skeleton width="70px" height="18px" center />
          </S.TextFooter>
        </S.Bottom>
      </div>
    </S.Wrapper>
  )
}

export default Loading
